import { Starc, Text, Link } from '@az/starc-ui'
import { AppRouter } from './router/Router'
import { AuthProvider } from './shared/Auth2.0/AuthProvider'

const App = () => {
  return (
    <Starc>
      <AuthProvider
        settings={{
          baseURL: window.env?.VITE_AUTH_URL,
          tokenURL: window.env?.VITE_TOKEN_URL,
          publicClientID: window.env?.VITE_CLIENT_ID,
          redirectURI: window.env?.VITE_REDIRECT_URL,
          revokeURL: window.env?.VITE_REVOKE_URL,
          scope: ['openid', 'profile'], // <-- Sin azjobinfo ni groups
          skipAuthorization: false,
          disabledForDevelopment: window.env?.VITE_DEVELOPMENT_MODE,
        }}
      >
        <AppRouter />
      </AuthProvider>
    </Starc>
  )
}

export default App
